// src/api/apiKeyService.js
import apiClient from './axiosConfig'; 

const API_URL = process.env.REACT_APP_API_URL || '';

const handleApiError = (error, operation) => {
  console.error(`${error.config?.method?.toUpperCase()} ${error.config?.url} - Error ${operation}:`, error); // Improved logging
  let message = 'An unknown error occurred.';
  const status = error.response?.status; // Get status code

  if (error.response?.data) {
    const d = error.response.data;
    // Check for FastAPI/Pydantic detail structure first
    if (typeof d.detail === 'string') {
        message = d.detail;
    } else if (Array.isArray(d.detail)) {
        // Handle validation errors (list of location/msg/type)
        // Format them into a readable string
        message = d.detail.map(err => {
            const loc = err.loc?.slice(1).join('.') || 'field'; // Remove 'body'/'query' prefix
            return `${loc}: ${err.msg}`;
        }).join('; ');
         if (!message) message = "Validation error"; // Fallback if detail is empty array
    } else if (typeof d === 'string' && d.length < 500) { // Avoid logging huge HTML responses
        message = d;
    } else if (d.message && typeof d.message === 'string') { // Fallback for other error structures
        message = d.message;
    } else if (status) {
         message = `Request failed with status code ${status}`; // Generic status message
    }
     // If it seems like HTML, don't use it as the message
     if (typeof message === 'string' && message.trim().startsWith('<')) {
         message = `Request failed with status code ${status || 'unknown'}`;
     }

  } else if (error.message) { // Network errors, etc.
    message = error.message;
  }

  // Include original error for potential debugging in UI or logs
  return {
    isError: true,
    message,
    status: status, // Add status code here
    originalError: error
  };
};

export const apiKeyService = {
  /** GET /api/v1/api-keys */
  getAllKeys: async () => {
    try {
      const { data } = await apiClient.get(`${API_URL}/api/v1/api-keys`);
      return data;
    } catch (err) {
      return handleApiError(err, 'listing API keys');
    }
  },

  /**
   * POST /api/v1/api-keys
   * Body: { name, expires_in_days?, scopes? }
   */
  createKey: async (name, expiresInDays = 30, scopes = []) => {
    try {
      const { data } = await apiClient.post(`${API_URL}/api/v1/api-keys`, {
        name,
        expires_in_days: expiresInDays,
        scopes,
      });
      return data; // includes full key_value (display once)
    } catch (err) {
      return handleApiError(err, 'creating API key');
    }
  },

  /** DELETE /api/v1/api-keys/{keyId} */
  revokeKey: async (keyId) => {
    try {
      await apiClient.delete(`${API_URL}/api/v1/api-keys/${keyId}`);
      return { success: true };
    } catch (err) {
      return handleApiError(err, `revoking API key ${keyId}`);
    }
  },
};
